/* Billy policy page: highlight the table-of-contents link for the section currently in view. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.billyPolicyReady || !('IntersectionObserver' in window)) return;
    root.dataset.billyPolicyReady = 'true';
    const links = Array.from(root.querySelectorAll('.billy-policy__toc-link'));
    const items = links.map((a) => document.getElementById(a.hash.slice(1))).filter(Boolean);
    if (!items.length) return;

    const setActive = (id) => {
      links.forEach((a) => {
        const on = a.hash === `#${id}`;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    };

    const visible = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
        const first = items.find((el) => visible.has(el));
        if (first) setActive(first.id);
      },
      { rootMargin: '-20% 0px -55% 0px' }
    );
    items.forEach((el) => io.observe(el));
    links.forEach((a) => a.addEventListener('click', () => setActive(a.hash.slice(1))));
  };

  const boot = () => document.querySelectorAll('[data-billy-policy]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
